import { notifications } from '@mantine/notifications';
import { IconBell } from '@tabler/icons-react';
import type { Communication } from '@medplum/fhirtypes';
import { createElement } from 'react';
import { getNotificationBody, getNotificationTitle } from './notificationFhir';

export interface ShowInAppNotificationToastOptions {
  onClick?: () => void;
}

const PORTAL_DECISION_ACCEPT_TITLES = new Set([
  'appointment confirmed',
  'reschedule accepted',
]);

const PORTAL_DECISION_DECLINE_TITLES = new Set([
  'appointment request declined',
  'reschedule declined',
]);

const TOAST_BORDER_BY_COLOR = {
  blue: '#9CA3AF',
  green: 'var(--mantine-color-green-4)',
  red: 'var(--mantine-color-red-4)',
} as const;

/** Map lifecycle notification titles to Mantine toast colors. */
export function getInAppNotificationToastColor(title: string): keyof typeof TOAST_BORDER_BY_COLOR {
  const normalized = title.trim().toLowerCase();
  if (PORTAL_DECISION_ACCEPT_TITLES.has(normalized)) return 'green';
  if (PORTAL_DECISION_DECLINE_TITLES.has(normalized)) return 'red';
  return 'blue';
}

/** Transient toast for a realtime in-app notification (bell popover uses the same fields). */
export function showInAppNotificationToast(
  comm: Communication,
  opts?: ShowInAppNotificationToastOptions,
): void {
  if (!comm.id) return;

  const title = getNotificationTitle(comm);
  const body = getNotificationBody(comm);
  const color = getInAppNotificationToastColor(title);

  notifications.show({
    id: `in-app-notif-${comm.id}`,
    icon: createElement(IconBell, { size: 18 }),
    title,
    message: body || ' ',
    color,
    withCloseButton: true,
    withBorder: true,
    autoClose: 5000,
    styles: {
      root: {
        borderColor: TOAST_BORDER_BY_COLOR[color],
        cursor: opts?.onClick ? 'pointer' : undefined,
      },
    },
    onClick: opts?.onClick,
  });
}
